import { DmSettingsResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type DmSettingsResponseInput = z.input<typeof DmSettingsResponseSchema>;
export type DmSettingsResponseOutput = z.output<typeof DmSettingsResponseSchema>;

export function serializeDmSettingsResponse(payload: DmSettingsResponseInput): DmSettingsResponseOutput {
  return DmSettingsResponseSchema.parse(payload);
}
